/** Marketing fixtures for Class & School landing cards. */

import { CLASS_DEMO_PATH } from "./demoClassExperience";
import { SCHOOL_DEMO_PATH } from "./demoSchoolExperience";

export { CLASS_DEMO_PATH, SCHOOL_DEMO_PATH };

export const CLASS_LANDING_FIXTURE = {
  id: "class",
  coverColor: "amber",
  eyebrow: "Class series",
  title: "Salsa Level 2",
  subtitle: "Students book online. Instructors check them in at the door from any phone.",
  stepsLabel: "Student ~1 min · Instructor ~4 min",
  location: "Berlin",
  chips: [
    { label: "12 / 15 enrolled" },
    { label: "Credit at check-in" },
  ],
  cta: "Try class check-in →",
  ctaColor: "night",
  to: CLASS_DEMO_PATH,
  openChooser: "class",
  testId: "demo-landing-class",
  ctaTestId: "demo-landing-class-cta",
};

export const SCHOOL_LANDING_FIXTURE = {
  id: "school",
  coverColor: "purple",
  eyebrow: "Dance school",
  title: "Sala Caracas Dance Academy",
  subtitle: "Manage door check-ins, payments, and multi-teacher schedules in one place.",
  stepsLabel: "Owner ~6 min",
  location: "Berlin",
  chips: [
    { label: "2 studios" },
    { label: "Door attendance" },
  ],
  cta: "Open school demo →",
  ctaColor: "plum",
  to: SCHOOL_DEMO_PATH,
  testId: "demo-landing-school",
  ctaTestId: "demo-landing-school-cta",
};

export const HOME_FEATURE_BLOCKS = [
  {
    id: "instructors-owners",
    title: "Built for dance hosts and schools",
    subtitle: "Powerful management tools without the technical overhead.",
    items: [
      {
        title: "Mobile attendance",
        body: "Track guest check-ins directly from your phone. Skip the spreadsheets.",
      },
      {
        title: "Direct payouts",
        body: "Connect your payment processor and keep 100% of your revenue. We never hold your funds.",
      },
      {
        title: "Lead and Follow balance",
        body: "Monitor role ratios in real time to balance your classes before doors open.",
      },
      {
        title: "Events are free forever",
        body: "No ticket cuts, no setup fees. Studio tools from ~$12/mo.",
      },
    ],
  },
];
